/**
 * Runtime configuration
 *
 * Values that differ per deployment environment (dev/prod) but ship in a single
 * build artifact. `VITE_*` env vars are baked at build time, so the same image
 * cannot carry a per-environment value — the server injects these into
 * index.html at serve time as `window.__RUNTIME_CONFIG__` (see src/server.ts).
 *
 * Resolution order for each value:
 *   1. window.__RUNTIME_CONFIG__ — runtime-injected (single-container deploys)
 *   2. import.meta.env.VITE_*    — build-time (local dev via .env)
 *   3. hardcoded default         — last resort
 */

export interface RuntimeConfig {
  /** Base URL of the Pathful app that hosts login (no trailing slash). */
  pathfulAppUrl?: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

const stripTrailingSlash = (url: string): string => url.replace(/\/$/, '');

/** Base URL of the Pathful app to redirect to for login on a 401. */
export function getPathfulAppUrl(): string {
  const runtime = globalThis.window?.__RUNTIME_CONFIG__?.pathfulAppUrl;
  const buildTime = import.meta.env.VITE_PATHFUL_APP_URL;
  return stripTrailingSlash(runtime || buildTime || 'https://app.pathful.com');
}
